import React from "react";

const DAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const DAY_IDS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export default function PreviewStep({ state, lists = [], accounts = [], onEdit }) {
  const selectedLists = (lists || []).filter((l) => (state.leadListIds || []).includes(l.id));
  const selectedSenders = (accounts || []).filter((a) =>
    (state.linkedinAccountIds || []).includes(a.id),
  );
  const activeDays = new Set((state.activeDays || []).map((d) => d.toLowerCase()));
  const opts = state.excludeOptions || {};

  const Row = ({ title, children, step }) => (
    <div className="flex items-start justify-between gap-4 py-4 border-b border-gray-100">
      <div className="min-w-0">
        <div className="text-sm font-semibold text-gray-900">{title}</div>
        <div className="text-sm text-gray-600 mt-1">{children}</div>
      </div>
      <button
        type="button"
        onClick={() => onEdit?.(step)}
        className="text-sm text-blue-600 shrink-0"
      >
        Edit
      </button>
    </div>
  );

  return (
    <div className="max-w-3xl mx-auto">
      <h2 className="text-xl font-semibold text-gray-900">Campaign overview</h2>
      <p className="text-sm text-gray-500 mt-1 mb-6">
        Review and edit campaign settings to make sure everything is set before launching it.
      </p>

      <Row title="Leads source" step="leads">
        {selectedLists.length > 0
          ? selectedLists.map((l) => l.name).join(", ")
          : "No lead list selected"}
      </Row>

      <Row title="Scheduled to start & end" step="schedule">
        {(state.startDate
          ? new Date(state.startDate).toLocaleDateString()
          : "Not set")}
        {" — "}
        {state.endDate ? new Date(state.endDate).toLocaleDateString() : "No end date"}
      </Row>

      <Row title="Active hours" step="schedule">
        {state.activeHoursStart || "09:00"} - {state.activeHoursEnd || "19:00"}{" "}
        {state.timezone || "UTC"}
      </Row>

      <Row title="Days" step="schedule">
        <div className="flex gap-1 mt-1">
          {DAY_IDS.map((id, i) => (
            <span
              key={id}
              className={`px-2 py-0.5 rounded text-xs ${
                activeDays.has(id)
                  ? "bg-blue-100 text-blue-700"
                  : "bg-gray-100 text-gray-400"
              }`}
            >
              {DAY_LABELS[i]}
            </span>
          ))}
        </div>
      </Row>

      <Row title="Senders" step="senders">
        {selectedSenders.length > 0
          ? selectedSenders
              .map((a) => a.accountName || `${a.firstName || ""} ${a.lastName || ""}`)
              .join(", ")
          : "No senders selected"}
      </Row>

      <Row title="Exclude options" step="leads">
        <div className="flex flex-wrap gap-2 mt-1">
          {opts.excludeOtherCampaigns ? (
            <span className="px-2 py-0.5 rounded-full bg-gray-100 text-xs">
              Exclude leads from other campaigns
            </span>
          ) : null}
          {opts.excludeMessagedByOtherSenders ? (
            <span className="px-2 py-0.5 rounded-full bg-gray-100 text-xs">
              Exclude leads from existing conversations
            </span>
          ) : null}
          {opts.excludeSameSenderOtherCampaigns ? (
            <span className="px-2 py-0.5 rounded-full bg-gray-100 text-xs">
              Exclude leads from sender in other campaigns
            </span>
          ) : null}
          {!opts.excludeOtherCampaigns
          && !opts.excludeMessagedByOtherSenders
          && !opts.excludeSameSenderOtherCampaigns ? (
            <span className="text-gray-400">None</span>
          ) : null}
        </div>
      </Row>

      <Row title="Sequence" step="sequence">
        {(state.steps || []).filter((s) => s.type !== "START" && s.type !== "END").length} action
        steps configured
      </Row>
    </div>
  );
}
